/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { KTIcon } from '../../../helpers'
import { getCSS, getCSSVariableValue } from '../../../assets/ts/_utils'
import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'
import clsx from 'clsx'
import { fetchData, formatNumber, toasterrormsg } from '../../../../reusable'
import moment from 'moment'
import Select from 'react-select';
import { Tr } from '../../../i18n/Tr'
import { useLang } from '../../../i18n/Metronici18n'
import { useIntl } from 'react-intl'

// register the non-english moment locales used by the language switcher
require('moment/locale/ru')
require('moment/locale/uz-latn')

// app language code -> moment locale (uz translations use the latin script)
const momentLocales: any = { en: 'en', ru: 'ru', uz: 'uz-latn' }

type Props = {
  className: string
  setActionDetails: any
}

const DashboardChart: React.FC<Props> = ({ className, setActionDetails }) => {
  const t = Tr()
  const lang = useLang()
  const intl = useIntl()
  const categoryId = sessionStorage.getItem('categoryId');
  var vendorId = "";
  const vendorData = sessionStorage.getItem("vendor");
  if (vendorData) {
    var vendor = JSON.parse(vendorData);
    vendorId = vendor.vendorId;
  } else {
    console.log("No vendor data found");
  }
  const [yearList, setYearList] = useState([]) as any
  const [selectedYear, setSelectedYear] = useState("") as any
  const monthList = [
    { value: '0', label: t('All Months') },
    ...Array.from({ length: 12 }, (_, i) => ({
      value: String(i + 1).padStart(2, '0'),
      label: moment().month(i).locale(momentLocales[lang] || 'en').format('MMMM'),
    })),
  ]
  const [selectedMonth, setSelectedMonth] = useState("") as any
  const [rawRevenueData, setRawRevenueData] = useState(null) as any;
  const [chartData, setChartData] = useState([]) as any

  const [categories, setCategories] = useState([]) as any
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()

  useEffect(() => {
    const chart = refreshChart()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, mode, chartData, selectedYear, selectedMonth])

  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }

    const height = parseInt(getCSS(chartRef.current, 'height'))

    const chart = new ApexCharts(chartRef.current, getChartOptions(height, chartData, categories))
    if (chart) {
      chart.render()
    }

    return chart
  }

  const getVendorId = (): string => {
    const raw = sessionStorage.getItem('vendor')
    const v = raw ? JSON.parse(raw) : null
    return v?.vendorId ? String(v.vendorId) : ''
  }

  // view vendor profile api call
  const viewProfileApiCall = async () => {
    const _vendorId = getVendorId()
    if (!_vendorId) return
    var param: any = {
      vendorId: _vendorId,
    }
    var res = await fetchData('public/viewProfile', param)

    if (res.status == '200') {
      var data = res.data[0]
      const vendorCreatedYear = moment(data.created).year()
      const currentYear = moment().year()
      const tempYearList = [];
      for (let i = currentYear; i >= vendorCreatedYear; i--) {
        tempYearList.push({ label: `${i}`, value: `${i}` }); // Push year to list
      }
      setYearList(tempYearList);

    } else {
      toasterrormsg(res.message)

    }
  }
  useEffect(() => {
    viewProfileApiCall()
  }, []);

  const viewDashboardRevenueApiCall = async () => {
    const _vendorId = getVendorId()
    if (!_vendorId) return
    const param = {
      categoryId: categoryId,
      vendorId: _vendorId,
      year: selectedYear,
      month: selectedMonth
    }
    var response = await fetchData('public/vendordashboard', param)

    if (response.status == '200') {
      const data = response.data.data
      const totalActionDetail = {
        totalAction: response.data.totalAction,
        totalCompletedBooking: response.data.totalCompletedBooking,
        totalCancelledBooking: response.data.totalCancelledBooking,
        totalBooking: response.data.totalCompletedBooking + response.data.totalCancelledBooking,
        totalVisitor: response.data.totalVisitor,
      }
      setActionDetails(totalActionDetail);
      setCategories([selectedYear ? selectedYear : moment().year()])
      // setChartData([
      //   { name: t('Total Revenue'), data: [parseFloat(data.totalAmount) > 0 ? data.totalAmount : ''] },
      //   { name: t('Vendor Revenue'), data: [parseFloat(data.vendorRevenue) > 0 ? data.vendorRevenue : ''] }
      // ])
      setRawRevenueData({
        totalAmount: parseFloat(data.totalAmount) > 0 ? data.totalAmount : '',
        vendorRevenue: parseFloat(data.vendorRevenue) > 0 ? data.vendorRevenue : ''
      });
    } else {
      // toasterrormsg(response.message)

    }
  }

  useEffect(() => {
    viewDashboardRevenueApiCall()
  }, [categoryId, vendorId, selectedYear, selectedMonth]);

  useEffect(() => {
    if (rawRevenueData) {
      setChartData([
        { name: t('Total Revenue'), data: [rawRevenueData.totalAmount] },
        { name: t('Vendor Revenue'), data: [rawRevenueData.vendorRevenue] }
      ])
    }
    // translations load asynchronously, so rename the series once they arrive
  }, [rawRevenueData, intl.messages]);
  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        {/* begin::Title */}
        <h3 className='card-title align-items-start flex-column'>
          <KTIcon iconName={'check-circle'} className={clsx('', 'fs-2hx ms-n1 flex-grow-1')} />
          <span className='card-label fw-bold fs-4 mb-1 mt-5'>{t('Total Earning')}</span>
        </h3>
        {/* end::Title */}
      </div>
      {/* end::Header */}

      {/* begin::Body */}
      <div className='card-body'>
        <div className="row">
          <div className="col-lg-6"></div>
          <div className="col-lg-3">
            <Select
              name='year'
              id='year'
              placeholder={t('Select Year')}
              isSearchable={true}
              isClearable={true}
              options={yearList}
              value={yearList.find(
                (option: any) => option.value == selectedYear
              ) || ""}
              onChange={(e: any) => { setSelectedYear(e ? e.value : ''); }}
            />
          </div>
          <div className="col-lg-3">
            <Select
              name='month'
              id='month'
              placeholder={t('Select Month')}
              isSearchable={true}
              isClearable={true}
              options={monthList}
              value={monthList.find(
                (option: any) => option.value == selectedMonth
              ) || ""}
              onChange={(e: any) => { setSelectedMonth(e ? e.value : ''); }}
            />
          </div>
        </div>
        {/* begin::Chart */}
        <div ref={chartRef} id='kt_charts_widget_1_chart' style={{ height: '450px' }} />
        {/* end::Chart */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export { DashboardChart }

function getChartOptions(
  height: number,
  data: any,
  categories: string[]
): ApexOptions {
  const labelColor = getCSSVariableValue('--bs-gray-500')
  const borderColor = getCSSVariableValue('--bs-gray-200')
  const baseColor = getCSSVariableValue('--greencolorprofit')
  const secondaryColor = getCSSVariableValue('--greencolorrevenue')
  
  return {
    series: data,
    chart: {
      fontFamily: 'inherit',
      type: 'bar',
      height: height,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '30%',
        borderRadius: 5,
      },
    },
    legend: {
      show: true, // Enable the legend
      position: 'bottom', // Position it below the chart
      horizontalAlign: 'center',
      markers: {
        width: 12,
        height: 12,
        radius: 12,
      },
      labels: {
        colors: labelColor,
        useSeriesColors: true,
      },
      itemMargin: {
        horizontal: 10,
        vertical: 5,
      },
      onItemClick: {
        toggleDataSeries: false, // Disable clicking on the legend to hide/show series
      },
      onItemHover: {
        highlightDataSeries: false, // Disable highlighting on hover
      },
    },

    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: categories,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
        formatter: function (val) {
          return val.toFixed(2)
        },
      },
    },
    fill: {
      opacity: 1,
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: function (val: any) {
          return formatNumber(parseFloat(val)) + ' UZS'
        },
      },
    },
    colors: [baseColor, secondaryColor],
    grid: {
      borderColor: borderColor,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
  }
}
